import React from "react";
import _ from "lodash";
import { getAutoPilotConfigSchema } from "../constants/AutoPilotConfig";
import DateTimeFormatter from "../../common/DateTimeFormatter";
import AutoPilotConfig from "./config/AutoPilotConfig";
import ConfigDiffView from "./config/ConfigDiffView";
import ScrollToTop from "../../common/ScrollToTop";
import { MESSAGE } from "constants/Message";

class AutoPilotConfigControl extends React.Component {
  constructor(props) {
    super(props);

    // { enabled: true, forerunner: {...} }
    const {
      config,
      defaultConfig,
      isUnitConfig,
      isHintConfig,
      feature,
      networkId,
    } = this.props;

    // { system: {sectionTitle, config...}, forerunner: {...} }
    const schemasGroupedBySection = getAutoPilotConfigSchema(
      defaultConfig,
      isHintConfig,
      isUnitConfig
    );

    if (!isUnitConfig) {
      const item = _.find(schemasGroupedBySection.prophet.configSchemas, {
        key: "cst_nopb_traffic_report_source",
      });
      if (item) {
        const isNopbEnabled =
          feature.reporting &&
          feature.reporting.enableCSTNopbKey20NopbValue &&
          feature.reporting.enableCSTNopbKey20NopbValueReport;
        item.msgFunc = (value, key) => {
          if (value === "Key20NopbValue" && !isNopbEnabled) {
            return [
              <span className="text-sm" key={`${key}-msg`}>
                "Enable CST Nopb Key 20 Nopb Value" and "Enable CST Nopb Key 20
                Nopb Value Report" should be set to true in{" "}
                <a
                  className="text-blue-600 hover:text-blue-800"
                  href={`${window.location.origin}/#/ops-mgmt/account/network/${networkId}/features`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Network Features
                </a>
              </span>,
              MESSAGE.WARNING,
            ];
          } else if (value !== "Key20NopbValue" && isNopbEnabled) {
            return [
              <span className="text-sm" key={`${key}-msg`}>
                Set this option to "Key20NopbValue" to complete the CST Nopb
                Key20 setup. (Since "Enable CST Nopb Key 20 Nopb Value" and
                "Enable CST Nopb Key 20 Nopb Value Report" in{" "}
                <a
                  className="text-blue-600 hover:text-blue-800"
                  href={`${window.location.origin}/#/ops-mgmt/account/network/${networkId}/features`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Network Features
                </a>{" "}
                are enabled)
              </span>,
              MESSAGE.WARNING,
            ];
          }
          return [];
        };
      }
    }

    this.state = {
      isEditing: false,

      schemasGroupedBySection,

      defaultConfig,
      originalConfig: config,
      newConfig: _.cloneDeep(config),
    };

    this.handleApplyChanges = this.handleApplyChanges.bind(this);
    this.handleSaveClicked = this.handleSaveClicked.bind(this);
  }
 
  componentDidUpdate(prevProps) {
    if (this.props.config !== prevProps.config) {
      this.setState({
        originalConfig: this.props.config,
        newConfig: _.cloneDeep(this.props.config),
      });
    }
  }

  handleApplyChanges({ sectionConfigKey, configKey, newValue, isUseDefault }) {
    console.log("apply changes", {
      sectionConfigKey,
      configKey,
      newValue,
      isUseDefault,
    });

    let newConfig = this.state.newConfig;

    if (isUseDefault) {
      // remove from config
      if (sectionConfigKey) {
        _.unset(newConfig, [sectionConfigKey, configKey]);
      } else {
        _.unset(newConfig, configKey);
      }
    } else {
      // add/edit to config
      if (sectionConfigKey) {
        _.set(newConfig, [sectionConfigKey, configKey], newValue);
      } else {
        _.set(newConfig, configKey, newValue);
      }
    }

    // // remove if allowed_device_categories is empty
    // if (
    //   _.has(newConfig, "segmentation.allowed_device_categories") &&
    //   newConfig.segmentation.allowed_device_categories === ""
    // ) {
    //   newConfig.segmentation = _.omit(
    //     newConfig.segmentation,
    //     "allowed_device_categories"
    //   );
    // }

    // to remove empty array values like ad_sizes
    // eg. {allowed_ad_sizes: []} -> {}
    // The following keys are allowed to have empty value!
    // forbid_client_refresh_labels
    newConfig.prophet = _.omitBy(newConfig.prophet, (c, key) => {
      if (key === "forbid_client_refresh_labels") return false;
      return typeof c === "object" && _.isEmpty(c);
    });

    // empty keys with empty object or array value
    // eg. {"forerunner": {} } -> {}
    newConfig = _.omitBy(newConfig, (c) => {
      return typeof c === "object" && _.isEmpty(c);
    });

    this.setState({
      isEditing: false,
      newConfig,
    });
  }

  handleSaveClicked() {
    this.props.handleSaveConfig({
      config: this.state.newConfig,
      // networkId,
      // unitId,
    });
  }

  render() {
    const {
      isEditing,
      schemasGroupedBySection,
      newConfig,
      originalConfig,
      defaultConfig,
    } = this.state;
    const { unitId, networkId, updatedAt, isHintConfig } = this.props;

    return (
      newConfig && (
        <>
          <div className="mt-2 flex">
            {/* MAIN CONFIG */}
            <div className="w-2/3">
              <AutoPilotConfig
                unitId={unitId}
                networkId={networkId}
                isEditing={isEditing}
                isHintConfig={isHintConfig}
                handleStartEditMode={() => {
                  this.setState({ isEditing: true });
                }}
                handleCancelEditMode={() => {
                  this.setState({ isEditing: false });
                }}
                handleApplyChanges={this.handleApplyChanges}
                schemasGroupedBySection={schemasGroupedBySection}
                newConfig={newConfig}
              ></AutoPilotConfig>
            </div>

            {/* SIDE */}
            <div className="fixed bottom-0 right-0 w-1/3" style={{ top: 108 }}>
              {updatedAt && (
                <div className="text-sm text-gray-600">
                  Last update time:
                  <br />
                  <DateTimeFormatter datetime={updatedAt}></DateTimeFormatter>
                </div>
              )}

              <div className="mt-8">
                <div className="overflow-y-auto" style={{ maxHeight: "420px" }}>
                  <ConfigDiffView
                    originalConfig={originalConfig}
                    newConfig={newConfig}
                    defaultConfig={defaultConfig}
                  ></ConfigDiffView>
                </div>

                <div className="my-4 text-center">
                  <button
                    type="button"
                    disabled={isEditing}
                    className={`rounded shadow bottom-0 p-4 font-semibold text-white ${
                      isEditing
                        ? "cursor-not-allowed bg-gray-400"
                        : "bg-blue-400 hover:bg-blue-600"
                    }`}
                    onClick={this.handleSaveClicked}
                  >
                    {isHintConfig ? (
                      <span>
                        Preview <b>hint config</b> then save
                      </span>
                    ) : (
                      <span>
                        Preview <b>base config</b> then save
                      </span>
                    )}
                  </button>
                </div>
              </div>

              <div>
                <ScrollToTop></ScrollToTop>
              </div>
            </div>
          </div>
        </>
      )
    );
  }
}

export default AutoPilotConfigControl;
